import React from 'react'
import Img from "gatsby-image"

import HeroSmall from '../components/HeroSmall'
import LocationMicroNav from '../components/LocationMicroNav'
import LocationContent from '../components/LocationContent'
import LocationRelated from '../components/LocationRelated'

class MontanaLocation extends React.Component {
  render() {
    return (
      <div>
        <HeroSmall location="Montana" />
        <LocationMicroNav />

        <LocationContent 
          category="Govt—State + Local" 
          title="Big Sky Country"
          story="We put our 1.25 million individual members to work, encouraging them to take action on issues related to bike riding in their communities. In 2017 we sent action alerts to our members from coast to coast. One of our signature victories came when we helped defeat a bad bike bill in Montana that would have required out-of-state bikes riders to purchase a $25 sticker for each bike they ride in the state."
        />      
        <Img
          title="Montana"
          alt="Montana Outdoor Scene"
          sizes= { this.props.data.montanaImage.sizes }
        />             

        <LocationRelated 
          prevLocationName="Charlotte, NC"
          prevLocationPath="charlotte"
          prevLocationImgPath= { this.props.data.montanaPrevImage }
          nextLocationName="Washington, DC"
          nextLocationPath="washington-dc"
          nextLocationImgPath= { this.props.data.montanaNextImage }
        /> 
      </div>
    )
  }
}

export default MontanaLocation

export const MontanaImageQuery = graphql`
  query montanaImageQuery {
    montanaImage: imageSharp(id: { regex: "/PFB_Montana/" }) {
      sizes(maxWidth: 1600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },    
    montanaPrevImage: imageSharp(id: { regex: "/PFB_CHARLOTTE/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    montanaNextImage: imageSharp(id: { regex: "/PFB_WASHINGTONDC/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/montana.js